import { TImageStore } from '@monorepo/types';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectImageStore = createFeatureSelector<TImageStore>('INPUT_APP_IMAGE_DB');
export const getImageDBLockDetailsAndNextCacheResetTime = createSelector(selectImageStore, (imageStore) => {
  return {
    lockDetails: imageStore.imagesBucketDBLockDetails,
    nextCacheResetTimestamp: imageStore.imagesBucketDB.nextCacheResetTimestamp,
  };
});

export const getAllDBsLockDetails = createSelector(selectImageStore, (imageStore) => {
  return {
    bgDbLockDetails: imageStore.imagesBucketMetadataDBLockedDetails,
    userDBLockDetails: imageStore.imagesBucketDBLockDetails,
    serverImageDBLockDetails: imageStore.serverImagesBucketMetadataDBLockedDetails,
  };
});

export const getSyncedImagesBucketDBLockDetailsAndNextCacheResetTime = createSelector(
  selectImageStore,
  (imageStore) => {
    return {
      lockDetails: imageStore.imagesBucketMetadataDBLockedDetails,
      nextCacheResetTimestamp: imageStore.imagesBucketMetadataDB.nextCacheResetTimestamp,
    };
  },
);

export const getServerImagesBucketDBLockDetailsAndNextCacheResetTime = createSelector(
  selectImageStore,
  (imageStore) => {
    return {
      lockDetails: imageStore.serverImagesBucketMetadataDBLockedDetails,
      nextCacheResetTimestamp: imageStore.serverImagesBucketDB.nextCacheResetTimestamp,
    };
  },
);

export const getAllImagesBucketDBs = createSelector(selectImageStore, (imageStore) => {
  return {
    imagesBucketDB: imageStore.imagesBucketDB,
    imagesBucketMetadataDB: imageStore.imagesBucketMetadataDB,
    serverImagesBucketDB: imageStore.serverImagesBucketDB,
  };
});
